import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Stepper from "@material-ui/core/Stepper";
import clsx from "clsx";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepConnector from "@material-ui/core/StepConnector";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import blueCircle from "../../../../../assets/svg/dashboard/blueCircle.svg";
import engagementSessionMom from "../../../../../assets/svg/engagementSessionMom.svg";
import engagementRequestSent from "../../../../../assets/svg/engagementRequestSent.svg";
import engagementRequestAccepted from "../../../../../assets/svg/engagementRequestAccepted.svg";
import engagementScheduleSession from "../../../../../assets/svg/engagementScheduleSession.svg";
import engagementMentorshipCompleted from "../../../../../assets/svg/engagementMentorshipCompleted.svg";
import { Box } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  mobile: {
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
    },
  },
  mobile2: {
    [theme.breakpoints.down("md")]: {
      marginTop: "100px",
    },
  },
  mobile3: {
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
}));

function getSteps() {
  return [1, 2, 3, 4, 5];
}

function getStepContent(stepIndex) {
  switch (stepIndex) {
    case 0:
      return "Select campaign settings...";
    case 1:
      return "What is an ad group anyways?";
    case 2:
      return "This is the bit I really care about!";
    default:
      return "Unknown stepIndex";
  }
}

const CustomStepIcon = () => {
  return (
    <div style={{ height: "100%" }}>
      <img style={{ height: "120px" }} src={blueCircle} />
    </div>
  );
};

export default function HorizontalLabelPositionBelowStepper(props) {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const steps = getSteps();

  return (
    <Box  className="rootdivdata" >
      <Box
        style={{
          // display: "flex",
          justifyContent: "space-around",
          padding: "0 80px",
          position: "relative",
        }}
        className={clsx(classes.mobile, "stepperformenengage")}
      >
        <Box
          style={{
            height: "3px",
            width: "90%",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "#9898e1",
          }}
          className={classes.mobile3}
        >
          <Box
            style={{
              position: "absolute",
              left: 0,
              top: "50%",
              transform: "translateY(-50%)",
              height: "15px",
              width: "15px",
              borderRadius: "50%",
              backgroundColor: "#9898e1",
            }}
          ></Box>
          <Box
            style={{
              position: "absolute",
              right: 0,
              top: "50%",
              transform: "translateY(-50%)",
              height: "15px",
              width: "15px",
              borderRadius: "50%",
              backgroundColor: "#9898e1",
            }}
          ></Box>
          <Box></Box>
          {}
        </Box>
        {[
          {
            logo: engagementRequestSent,
            title: "SEND REQUEST",
          },
          {
            logo: engagementRequestAccepted,
            title: "REQUEST ACCEPTED",
          },
          {
            logo: engagementScheduleSession,
            title: "SCHEDULE SESSION",
          },
          {
            logo: engagementSessionMom,
            title: "SESSION NOTES",
          },
          {
            logo: engagementMentorshipCompleted,
            title: "COMPLETED MENTORSHIP",
          },
        ].map((ele, index) => (
          <Box
            key={index}
            style={{
              height: "100px",
              width: "100px",
              borderRadius: "50%",
              border: "1px solid #3ad2d7",
              borderStyle: "dashed",
              // backgroundColor:props.data&&props.data=="CLOSED"?"#90cfd9": index===0 ||index===1?"#90cfd9":index===2?"#3ac2d7":"#f4f4f4",
              backgroundColor:
                props.data && props.data == "CLOSED"
                  ? "#90cfd9"
                  : index === 0 || index === 1
                  ? "#90cfd9"
                  : index === 2 && props.sessionNotesToggle !== true
                  ? "#3ac2d7"
                  : index === 2 && props.sessionNotesToggle === true
                  ? "#90cfd9"
                  : index === 3 &&
                    props.sessionNotesToggle &&
                    props.sessionNotesToggle == true &&
                    props.completedMentorshipToggle !== true
                  ? "#3ac2d7"
                  : index === 3 &&
                    props.sessionNotesToggle &&
                    props.sessionNotesToggle == true &&
                    props.completedMentorshipToggle === true
                  ? "#90cfd9"
                  : index === 4 &&
                    props.completedMentorshipToggle &&
                    props.completedMentorshipToggle == true
                  ? "#3ac2d7"
                  : "#e9e9e9",
              position: "relative",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            className={classes.mobile2}
          >
            <img src={ele.logo} style={{ height: "50px" }} />
            <Typography
              style={{
                position: "absolute",
                bottom: "-60px",
                fontFamily: "Montserrat",
                fontSize: "16px",
                color: "#277acc",
                fontWeight: "bold",
              }}
            >
              {ele.title}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
